import React from 'react'
import { useParams } from 'react-router'
import { Loading } from 'components/loading'
import { ScoutingVisualizationScreen } from 'domain/feature/hub/company/scouting/VisualizationScreen/index'
import { ScoutingHeader } from 'domain/feature/hub/company/scouting/VisualizationScreen/components/ScoutingHeader'
import { ScoutingPageContainer } from 'domain/feature/hub/company/scouting/VisualizationScreen/style'
import { Container } from 'react-bootstrap'
import { useGetOpportunityById } from 'domain/feature/hub/company/scouting/api/scoutingService'

export const HubScoutingGetPage = (): JSX.Element => {
  const { scoutingId } = useParams()

  const {
    data: scoutingResponse,
    isFetching: isScoutingFetching
  } = useGetOpportunityById(scoutingId || '')

  const scoutingData = scoutingResponse?.data
  const fileRows = scoutingData?.files ?? null

  const renderResponse = (): JSX.Element => {
    if (isScoutingFetching) {
      return <Loading />
    }

    if (!scoutingData) {
      return (
        <Container fluid>
          <div className="alert alert-warning">
            Oportunidade não encontrada.
          </div>
        </Container>
      )
    }

    return (
      <ScoutingPageContainer fluid>
        <ScoutingHeader data={scoutingData} />
        <ScoutingVisualizationScreen
          data={scoutingData}
          fileRows={fileRows}
        />
      </ScoutingPageContainer>
    )
  }

  return <>{renderResponse()}</>
}
